import {Component} from '@angular/core';

@Component({
  selector: 'notfound-page',
  templateUrl: './404.page.html',
  styleUrls: ['./404.page.scss']
})
export class NotFoundPage {
}
